<template>
  <a
    v-if="isExternal"
    class="no-underline hover:underline rounded-sm"
    :href="link"
    target="_blank"
  >
    <slot />
  </a>
  <router-link
    v-else
    v-bind="$props"
    :to="link"
    class="no-underline hover:underline rounded-sm"
  >
    <slot />
  </router-link>
</template>

<script>
export default {
  /** pass router-link props
   * link => href/to
   */
  props: [
    "link",
    "activeClass",
    "append",
    "event",
    "exact",
    "exactActiveClass",
    "replace",
    "tag",
  ],
  computed: {
    isExternal() {
      if (this.link) {
        return typeof this.link === "object"
          ? false
          : this.link.startsWith("https://")
      }
      return false
    },
  },
}
</script>

<style scoped>
a {
  color: #0645ad;
}
</style>
